import React, { useRef, useEffect, useState } from 'react'
import $ from 'jquery';
import { fetchAvisosAtivos } from '../services/avisosService.js'
import { Map, TileLayer } from 'react-leaflet'
import L from 'leaflet'
import JsonEstados from '../assets/json/estados.json'
import { gerarVariaveisDeDias, filtrarAvisosPorData, dataAtualDDMMYYYY } from '../utils/avisosDatas.js'

import './css/Style.css'
import './css/Mobile.css'
import './css/HD-Screen.css'
import 'leaflet/dist/leaflet.css'

const Mapa = () => {
  const mapa = useRef(React.createRef)
  const avisosHojeRef = useRef(null)
  const iconesHojeRef = useRef(null)
  const avisosFuturoRef = useRef(null)
  const iconesFuturoRef = useRef(null)
  const rawFuturoRef = useRef([])
  const mapaInicializadoRef = useRef(false)

  const [avisosHoje, setAvisosHoje] = useState(null)
  const [iconesHoje, setIconesHoje] = useState(null)
  const [avisosFuturo, setAvisosFuturo] = useState(null)
  const [datasFutura, setDatasFutura] = useState({})
  const [carregandoAvisos, setCarregandoAvisos] = useState(true)

  const getMap = () => mapa.current && mapa.current.leafletElement

  const criarLayersAviso = (avisos) => {
    const poligonos = []
    const icones = []

    for (let i = 0; i < avisos.length; i++) {
      const aviso = avisos[i]
      L.geoJson(JSON.parse(aviso.poligono), {
        onEachFeature: function (feature, layer) {
          layer.options.fillColor = aviso.aviso_cor
          layer.options.fillOpacity = 0.7
          layer.options.color = aviso.aviso_cor
          layer.options.opacity = 1
          layer.options.weight = 1
          poligonos.push(layer)

          icones.push(
            L.marker(
              [layer.getBounds().getCenter().lat, layer.getBounds().getCenter().lng], {
                icon: L.icon({
                  iconUrl: aviso.icone,
                  iconAnchor: [17, 50],
                  popupAnchor: [2, -40]
                })
              }).bindPopup(`<b>${aviso.descricao}</b><br />Para mais informações <a href="/${aviso.id}" target="_blank">clique aqui</a>.`)
          )
        }
      })
    }

    return {
      poligonos: L.layerGroup(poligonos),
      icones: L.layerGroup(icones)
    }
  }

  const removerTodosLayers = () => {
    const map = getMap()
    if (!map) return
    if (avisosHojeRef.current) map.removeLayer(avisosHojeRef.current)
    if (iconesHojeRef.current) map.removeLayer(iconesHojeRef.current)
    if (avisosFuturoRef.current) map.removeLayer(avisosFuturoRef.current)
    if (iconesFuturoRef.current) map.removeLayer(iconesFuturoRef.current)
  }

  const mostrarHoje = () => {
    const map = getMap()
    if (!map) return
    removerTodosLayers()
    map.addLayer(avisosHojeRef.current)
    map.addLayer(iconesHojeRef.current)
  }

  const buildFuturoParaData = (dataSelecionadaStr) => {
    const avisosFiltrados = filtrarAvisosPorData(dataSelecionadaStr, rawFuturoRef.current)
    const { poligonos, icones } = criarLayersAviso(avisosFiltrados)

    const map = getMap()
    if (!map) return

    removerTodosLayers()
    avisosFuturoRef.current = poligonos
    iconesFuturoRef.current = icones
    map.addLayer(poligonos)
    map.addLayer(icones)
  }

  const popularSelectDatas = () => {
    const select = $('#avisos-data-select')
    if (!select.length) return
    select.empty()
    select.append('<option value="hoje" selected>Hoje</option>')
    Object.values(datasFutura).forEach(data => {
      select.append(`<option value="${data}">${data}</option>`)
    })
  }

  const obterDataBase = (avisosHoje) => {
    if (avisosHoje.length > 0 && avisosHoje[0].inicio) {
      const [ano, mes, dia] = avisosHoje[0].inicio.split(' ')[0].split('-')
      const hojeNovo = new Date();
      const novoInicio = `${hojeNovo.getDate()}/${hojeNovo.getMonth() + 1}/${hojeNovo.getFullYear()}`;
      // return `${dia}/${mes}/${ano}`
      return novoInicio
    }
    return dataAtualDDMMYYYY()
  }

  const getAvisos = async () => {
    setCarregandoAvisos(true)

    try {
      const data = await fetchAvisosAtivos()

      setDatasFutura(gerarVariaveisDeDias(obterDataBase(data.hoje)))

      const { poligonos, icones } = criarLayersAviso(data.hoje)
      avisosHojeRef.current = poligonos
      iconesHojeRef.current = icones
      setAvisosHoje(poligonos)
      setIconesHoje(icones)

      rawFuturoRef.current = data.futuro

      const futuroVazio = L.layerGroup([])
      avisosFuturoRef.current = futuroVazio
      iconesFuturoRef.current = futuroVazio
      setAvisosFuturo(futuroVazio)
    } catch (err) {
      console.log(err)
      alert('Erro ao carregar os dados dos avisos. Tente novamente.')
    } finally {
      setCarregandoAvisos(false)
    }
  }

  const adicionarControles = () => {
    const map = getMap()
    if (!map) return

    const checbox = L.control({ position: 'topright' })
    const options = `
      <div id='id-avisos-checks' class='input-container'>
        <span class='input-label'>Data</span>
        <select id='avisos-data-select'></select>
      </div>
    `

    checbox.onAdd = function() {
      let div = L.DomUtil.create('div', 'info legend');
      div.innerHTML = `
        <div class='leaflet-control-layers-expanded leaflet-control-layers style' id='checbox-menu-right'>
          ${options}
        </div>`;
      return div;
    }
    checbox.addTo(map)

    const legenda = L.control({ position: 'topleft' })
    legenda.onAdd = function() {
      let div = L.DomUtil.create('div', 'info legend');
      div.innerHTML = `
        <div class='leaflet-control-layers-expanded leaflet-control-layers style' id='id-legenda-left'>
          <div style="display: flex;"><div style="width: 20px; height: 20px; background-color: #FFFE00; margin-right: 10px; margin-bottom: 5px;"></div>Perigo Potencial</div>
          <div style="display: flex;"><div style="width: 20px; height: 20px; background-color: #F96602; margin-right: 10px; margin-bottom: 5px;"></div>Perigo</div>
          <div style="display: flex;"><div style="width: 20px; height: 20px; background-color: #F80703; margin-right: 10px;"></div>Grande Perigo</div>
        </div>`;
      return div;
    }
    legenda.addTo(map)

    const plus = L.control({ position: 'bottomright' })
    plus.onAdd = function() {
      let div = L.DomUtil.create('div', 'info legend');
      div.innerHTML = `
        <div id='id-plus-right'>
          <a href="https://avisos.inmet.gov.br" target="_blank">
            <img src='${require('../assets/img_mais.png')}' />
          </a>
        </div>`;
      return div;
    }
    plus.addTo(map)
  }

  const adicionarMarcaDagua = () => {
    const map = getMap()
    if (!map) return
    map.addLayer(L.imageOverlay(
      'https://portal.inmet.gov.br/uploads/icones/logosfundo.png',
      [[7.15, -75.4],[-35.7, -31.5]],
      { opacity: 0.8 }
    ))
  }

  const inicializarZoomMapa = () => {
    const map = getMap()
    if (!map) return
    const resolucao = parseInt((window.screen.availWidth / 20))
    let zoom = 2 + 0.06 * resolucao;
    if (zoom > 4.5) {
        zoom = 4.2
    }
    map.setZoom(zoom)
  }

  useEffect(() => {
    adicionarControles()
    getAvisos()
    adicionarMarcaDagua()

    const map = getMap()
    if (map) {
      map.addLayer(L.geoJson(JsonEstados, {
        color: 'black',
        fillColor: '#E5ECC3',
        weight: 1.1,
        fillOpacity: 1,
      }))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (Object.keys(datasFutura).length > 0) {
      popularSelectDatas()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [datasFutura])

  useEffect(() => {
    if (mapaInicializadoRef.current) return
    if (avisosHoje === null || avisosFuturo === null) return

    const map = getMap()
    if (!map) return

    mapaInicializadoRef.current = true
    inicializarZoomMapa()

    map.addLayer(avisosHoje)
    map.addLayer(iconesHoje)

    $('#avisos-data-select').off('change').on('change', function () {
      const valor = $(this).val()
      if (valor === 'hoje') {
        mostrarHoje()
      } else {
        buildFuturoParaData(valor)
      }
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [avisosHoje, avisosFuturo])

  return (
    <div className="mapa-loading-container">
      {carregandoAvisos && (
        <div className="avisos-loading-overlay">
          Carregando avisos...
        </div>
      )}
      <Map
        ref={mapa}
        className={'map-iframe'}
        style={{ width: '100vw', height: '100vh' }}
        zoom={4}
        scrollWheelZoom={false}
        center={[-15.6014, -59.597]}
        preferCanvas={'true'}
        doubleClickZoom={false}
        zoomControl={false}
        maxBounds={[[7.23542, -95.332414], [-35.67909, -16.362345]]}>
	<TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors' />
      </Map>
    </div>
  )
}
export default Mapa;
